import { useEffect } from 'react'
import { useRouter } from 'next/router'

import SystemUpdateModal from '~/components/Modals/SystemUpdateModal'
import useGetCurrentUserGrade from '~/hooks/useGetCurrentUserGrade'
import useGetGradeOverviewPageRoute from '~/dashboard/hooks/useGetGradeOverviewPageRoute'
import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'
import useProgressMigrationModal from '~/curriculum/hooks/useProgressMigrationModal'
import UpgradingScreen from '~/upgrading/components/UpgradingScreen'

export default function ProgressMigrationFlow(): React.ReactElement | null {
  const router = useRouter()
  const { acknowledgeModal, completeFlow, flowPhase, isAcknowledging, shouldShowFlow } = useProgressMigrationModal()
  const { grade, topicOrder } = useGetCurrentUserGrade()
  const gradeOverviewRoute = useGetGradeOverviewPageRoute({
    grade: grade ?? '',
    topicOrder: topicOrder ?? 1,
  })
  const selectGradeRoute = useGetGradePageRoute()
  const destinationRoute = grade ? gradeOverviewRoute : selectGradeRoute

  useEffect(() => {
    if (flowPhase !== 'done') return

    const navigateAndComplete = (): void => {
      completeFlow()
    }

    if (router.asPath.startsWith(destinationRoute)) {
      navigateAndComplete()
      return
    }

    void router.replace(destinationRoute).finally(navigateAndComplete)
  }, [completeFlow, destinationRoute, flowPhase, router])

  if (!shouldShowFlow) return null

  return (
    <div className="fixed inset-0 z-top">
      <UpgradingScreen />
      {flowPhase === 'modal' && <SystemUpdateModal isAcknowledging={isAcknowledging} onConfirm={acknowledgeModal} />}
    </div>
  )
}
